var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            "table-div-id": _vm.tableDivId,
            "show-filter": false,
            data: _vm.fetchData,
            "table-class": "table",
          },
        },
        [
          _c("table-column", {
            attrs: {
              label: _vm.$t(
                _vm.userType == "funder" || _vm.userType == "supplier"
                  ? "reports.pos.po_date"
                  : "invoices.date"
              ),
              "sort-as": "invoice_date",
              show: "formattedPurchaseOrderDate",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("invoices.due_date"),
              "sort-as": "due_date",
              show: "formattedExpiryDate",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.customer"), width: "20%" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    row.buyer_stakeholder
                      ? _c("p", [
                          _vm.userType == "supplier" &&
                          // row.customer.parent_account_id &&
                          row.buyer_stakeholder.details.company &&
                          row.buyer_stakeholder.details.company.name
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.buyer_stakeholder.details.company.name
                                    ) +
                                    "\n          "
                                ),
                              ])
                            : _vm.userType == "supplier"
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.buyer_stakeholder.details.user.name
                                    ) +
                                    "\n          "
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.buyer_stakeholder.details.company.name
                                    ) +
                                    "\n          "
                                ),
                              ]),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.supplier") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    row.supplier_stakeholder
                      ? _c("p", [
                          row.supplier_stakeholder.details.company &&
                          row.supplier_stakeholder.details.company.name
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.supplier_stakeholder.details.company
                                        .name
                                    ) +
                                    "\n          "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.status"), "sort-as": "status" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (row) {
                    return row.status
                      ? [
                          _c("span", [
                            _vm._v(" " + _vm._s(_vm.$t("invoices.status"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { class: "inv-status-" + row.status.toLowerCase() },
                            [_vm._v(_vm._s(row.status.toUpperCase()))]
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("pos.ref_num"), show: "reference_number" },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.amount"), "sort-as": "total" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$t("invoices.amount")))]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(
                            row.total,
                            row.user.account.currency
                          )
                        ),
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }